export const name = '@lifi/widget'
export const version = '3.32.2'
